angular.module('eStories.purchase', [
    'global.validation.model',
    'eStories.billing.model',
    'eStories.catalog.model'
]).controller('PurchaseCtrl',
    ['ValidationModel', 'AccountModel', 'BillingModel', 'LL', '$scope', 'GoogleModel', 'CatalogModel', 'GA',
        function (ValidationModel, AccountModel, BillingModel, LL, $scope, GoogleModel, CatalogModel, GA) {
            var purchaseCtrl = this;

            purchaseCtrl.CatalogModel = CatalogModel;

            BillingModel.getAllPlans(function (allPlansMap) {
                purchaseCtrl.allPlansMap = allPlansMap;
                safeApply($scope);
            });

            AccountModel.refreshSavedPaymentDetails();
            AccountModel.refreshSubscriptionDetails();

            purchaseCtrl.setPurchaseType = function (purchaseType) {
                AccountModel.setPendingAudiobookPurchase(purchaseCtrl.getAudiobook(), purchaseType);
            };

            purchaseCtrl.getPendingAudiobookPurchase = function () {
                return AccountModel.pendingAudiobookPurchase;
            };

            purchaseCtrl.getAudiobook = function () {
                if (purchaseCtrl.getPendingAudiobookPurchase() == null) {
                    return null;
                }
                return purchaseCtrl.getPendingAudiobookPurchase().audiobook;
            };

            purchaseCtrl.isMember = function () {
                return AccountModel.isMember();
            };

            purchaseCtrl.getPurchaseType = function () {
                if (purchaseCtrl.getPendingAudiobookPurchase() == null) {
                    return null;
                }
                return purchaseCtrl.getPendingAudiobookPurchase().purchaseType;
            };

            purchaseCtrl.isUserLoggedIn = function () {
                return AccountModel.isUserLoggedIn;
            };

            purchaseCtrl.getSavedPaymentDetails = function () {
                return AccountModel.savedPaymentDetails;
            };

            purchaseCtrl.getMemberPrice = function () {
                if (purchaseCtrl.getProduct() != null) {
                    return purchaseCtrl.getProduct().memberPrice;
                }
            };

            purchaseCtrl.getProductByGroup = function (purchaseType, audiobook) {
                if (audiobook == null) {
                    audiobook = purchaseCtrl.getAudiobook()
                }
                return AccountModel.getProductByGroup(purchaseType, audiobook);
            };

            purchaseCtrl.getProduct = function () {
                if (purchaseCtrl.getAudiobook() == null) {
                    return null;
                }

                return purchaseCtrl.getProductByGroup(purchaseCtrl.getPurchaseType());
            };

            purchaseCtrl.hasAvailableCredit = function () {
                return AccountModel.hasAvailableCredit();
            };

            purchaseCtrl.canBuyWithCredit = function () {
                if (purchaseCtrl.getAudiobook() == null || !purchaseCtrl.isMember()) {
                    return false;
                }
                return purchaseCtrl.isAlcPurchase() && purchaseCtrl.getProductByGroup("CREDIT") != null &&
                    purchaseCtrl.hasAvailableCredit();
            };

            purchaseCtrl.isOnTrial = function () {
                return AccountModel.isTrialMember();
            };

            purchaseCtrl.isAlcPurchase = function () {
                if (purchaseCtrl.getPendingAudiobookPurchase() == null) {
                    return false;
                }

                return purchaseCtrl.getPendingAudiobookPurchase().purchaseType === "RETAIL";
            };

            purchaseCtrl.isGiftCreditPurchase = function () {
                if (purchaseCtrl.getPendingAudiobookPurchase() == null) {
                    return false;
                }

                return purchaseCtrl.getPendingAudiobookPurchase().purchaseType === "CREDIT_GIFT";
            };

            purchaseCtrl.getPaymentDetailsText = function () {
                var savedPaymentDetails = purchaseCtrl.getSavedPaymentDetails();
                if (savedPaymentDetails == null) {
                    return "";
                }
                if (savedPaymentDetails.paymentMethod === "CREDIT_CARD") {
                    var creditCardDetails = savedPaymentDetails.creditCardDetails;
                    var cardType = creditCardDetails.cardType;
                    if (cardType === "American Express") {
                        cardType = "AMEX";
                    }
                    return cardType + " " + creditCardDetails.maskedNumber;
                } else {
                    return "PayPal";
                }
            };

            purchaseCtrl.purchasePendingAudiobook = async function (successCallback, errorCallback) {
                var audiobook = purchaseCtrl.getAudiobook();
                var purchaseType = purchaseCtrl.getPurchaseType();

                try {
                    const response = await BillingModel.purchaseAudiobook(audiobook.id, purchaseType);
                    if (response.responseText === "SUCCESS") {
                        var llAudiobookObject = LL.convertAudiobookToLocalyticsObject(audiobook);
                        var purchaseTag;
                        if (purchaseType === "RETAIL") {
                            purchaseTag = "Retail Purchase";
                            var myPrice = AccountModel.getMyAudiobookPrice(audiobook, false);
                            var currency = AccountModel.getProductByGroup('RETAIL', audiobook).currency;
                            GoogleModel.trackConversion("JAySCLLZqmcQ_puwuQM", parseFloat(myPrice), currency);
                            llAudiobookObject["Price Paid"] = myPrice;
                            GA.trackEvent('Purchase', 'Retail Purchase', audiobook.title, parseFloat(myPrice).toFixed(0));
                            llAudiobookObject["Currency"] = purchaseCtrl.getProduct().currency;
                        } else {
                            if (purchaseType === "CREDIT_GIFT") {
                                purchaseTag = "Redeem Gift Credit";
                            } else {
                                purchaseTag = "Redeem Credit";
                                llAudiobookObject["Member Price"] = purchaseCtrl.getMemberPrice();
                                llAudiobookObject["Currency"] = purchaseCtrl.getProduct().currency;
                            }
                            GA.trackEvent("Engagement", "Redeem Credit");
                        }

                        llAudiobookObject["Publisher"] = purchaseCtrl.getAudiobook().publisher.name;
                        llAudiobookObject["isDailyDeal"] = CatalogModel.dailyDeal ? purchaseCtrl.getAudiobook().id === CatalogModel.dailyDeal.id : false;

                        LL.tagEvent(purchaseTag, llAudiobookObject);

                        AccountModel.refreshSubscriptionDetails();

                        if (successCallback) successCallback();
                        return;
                    }

                    var error = null;
                    switch (response.responseText) {
                        case 'AUDIOBOOK_ALREADY_IN_LIBRARY':
                            error = 'You have already purchased this book. You can find it in \'My Library\'';
                            break;
                        case 'INVALID_PURCHASE_TYPE':
                            error = 'We are unable to complete your purchase of this book at this time. If this issue continues, please contact us at support@estories.com';
                            break;
                        case 'ACCESS_DENIED':
                            error = 'We are unable to complete your purchase at this time.  If the problem continues, please contact us at support@estories.com';
                            break;
                        case 'NO_SESSION':
                            error = 'We are unable to complete your purchase at this time. Please log in again, or contact us at support@estories.com';
                            break;
                        case 'PRODUCT_IS_NOT_AVAILABLE_IN_TERRITORY':
                            error = 'This book is currently unavailable in your country due to publisher restrictions';
                            break;
                        case 'PRODUCT_DOES_NOT_EXIST':
                            error = 'Sorry, this title is not available for purchase at this time. If you have questions, please contact us at support@estories.com';
                            break;
                        case "INVALID_PRODUCT_ID":
                        case 'PROVIDER_ERROR':
                        default:
                            error = "We are unable to complete your purchase of this book at this time. " +
                                " If this issue persists please contact us at support@estories.com (code: " + response.responseText + ")";
                            break;
                    }
                    if (errorCallback) errorCallback(error);
                } catch (e) {
                    if (errorCallback) errorCallback("Unable to purchase audiobook");
                }
            }
        }
    ]
);